<script lang="ts">
  import { navigate } from 'svelte-routing';
</script>

<svelte:head>
  <title>Page Not Found - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  <header>
    <h2>Page Not Found</h2>
  </header>

  <p>
    The page you're looking for doesn't exist.
  </p>
  <p>
    <a href="/" class="button" on:click|preventDefault={() => navigate('/')}>Return to home</a>
  </p>
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  #main > header:first-child {
    text-align: center;
  }

  @media screen and (max-width: 736px) {
    #main {
      padding: 2em;
    }
  }
</style>
